import React, { useCallback } from 'react';
import SearchField from 'components/Field/SearchField/SearchField';
import useFilters from 'hooks/useFilters';
import AgenciesFilters from 'components/AgenciesFilters/AgenciesFilters';
import { toggleActiveAgencies } from 'modules/toggle-active-agencies/toggle-active-agencies';
import Portal from 'components/Portal/Portal';
import FiltersBar from 'components/FiltersBar/FiltersBar';

export default function ManifestsFiltersBar({
  query,
  onChangeQuery = () => {},
  onFiltersChange = () => {},
}) {
  const [filters, setFilters] = useFilters(
    'manifestsFilters',
    onFiltersChange,
    {
      agency_id: [],
    },
  );

  const toggleAgencies = useCallback(
    (agency_id) => {
      const newActiveAgencies = toggleActiveAgencies(filters, agency_id);
      setFilters({ ...filters, agency_id: newActiveAgencies });
    },
    [filters, setFilters],
  );

  return (
    <FiltersBar>
      <FiltersBar.Row>
        <Portal.In target="page-header-right">
          <SearchField
            value={query}
            placeholder="Buscar…"
            onChange={onChangeQuery}
          />
        </Portal.In>
        <AgenciesFilters
          activeAgencies={filters?.agency_id}
          onToggleAgency={toggleAgencies}
        />
      </FiltersBar.Row>
    </FiltersBar>
  );
}
